import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import vi from "@languages/vi.json";
import en from "@languages/en.json";

i18n.use(initReactI18next).init({
    lng: "vi",
    fallbackLng: "vi",
    resources: {
        vi: { translation: vi },
        en: { translation: en },
    },
    interpolation: {
        escapeValue: false,
    },
});

export function i18nSSr() {
    const instance = i18n.createInstance();
    instance.init({
        lng: "vi",
        fallbackLng: "vi",
        resources: {
            vi: { translation: vi },
            en: { translation: en },
        },
        interpolation: {
            escapeValue: false,
        },
    });
    return instance;
}

export default i18n;
